<template>
  <CategoryPage />
</template>

<script>
import CategoryPage from '@/components/pages/CategoryPage.vue';

export default {
  name: 'CategoryView',
  components: {
    CategoryPage,
  },
};
</script>
